// ticket-vault.db.ts
import Dexie, { Table } from 'dexie';

export type ZTicketVaultStatus =
  | 'DRAFT'
  | 'COMMITTING_LOCAL'
  | 'COMMITTED_LOCAL'
  | 'SYNC_PENDING'
  | 'SYNCED'
  | 'ERROR';

export interface ZTicketVaultDocument {
  // PK stable (indépendant de DO_PIECE_INTERNAL)
  MD_DOGID: string;                 // UUID

  createdAt: number;             // Date.now()
  updatedAt: number;             // Date.now()
  status: ZTicketVaultStatus;

  // --- Champs miroir utiles pour filtres/index (tirés du ticket)
  MD_SITEGID?: string;
  MD_SITE?: string;
  MD_CAISSE?: string;
  MD_CAISSIER?: string;
  MD_CAISSE_SESSION?: string;
  MD_DATE_CREATION?: string;     // ISO string si tu veux rester aligné
  DO_DATE?: string;              // ISO string

  DO_PIECE?: string;
  DO_PIECE_INTERNAL?: string;    // pas PK !
  DO_PIECE_INTERNAL_PREVIOUS?: string | null;

  DO_TOTALHT?: number;
  DO_TOTALTTC?: number;
  DO_NETAPAYER?: number;
  DO_SOLDETTC?: number;
  DO_MONTANTREGLE?: number;

  ZTICKET_STATUS?: number;
  ZSYNCUP_STATUS?: string;
  ZSYNCUP_FLAG?: number;
  ZSYNCUP_ERROR_MESSAGE?: string;

  // Clé métier non unique (diagnostic / regroupement)
  ZV_BUSKEY?: string;            // ex "site|caisse|session|pieceInternal"

  // Snapshot complet du ticket
  ticket: any; // ou any si tu veux commencer simple
}

export class ZTicketVaultDb extends Dexie {
  tickets!: Table<ZTicketVaultDocument, string>;

  constructor() {
    super('dblinkupcashdesk_zticketvault'); // <- nom de la base IndexedDB
    
    // indexes conseillés
    // - MD_DOGID : PK
    // - updatedAt : tri récent
    // - status : retrouver les tickets non synchronisés
    // - MD_SITEGID, MD_CAISSE, MD_CAISSE_SESSION : contexte caisse
    // - MD_DATE_CREATION : recherche par date
    // - DO_PIECE_INTERNAL : recherche “métier”
    this.version(1).stores({
    tickets:
        'MD_DOGID, updatedAt, status, MD_SITEGID, MD_CAISSE, MD_CAISSE_SESSION, MD_DATE_CREATION, DO_PIECE_INTERNAL'
    });
  }
}
export const zTicketVaultDb = new ZTicketVaultDb();
